import type { IClaimElements, ITaskStockClaim } from '@interfaces/IScheduler';

// Deep equality over a task's stock claims — the drawer commits the set only
// when the draft actually differs from the stored execution record, so a Save
// that never touched the Stock tab (or a delivery raised for an existing claim)
// sends no stock-claims PUT. Order-sensitive on purpose: the set is edited and
// stored as one list, so a reorder IS a change.

function sameStrings(a: string[], b: string[]): boolean {
  return a.length === b.length && a.every((id, i) => id === b[i]);
}

function sameElements(a: IClaimElements[] | undefined, b: IClaimElements[] | undefined): boolean {
  if (!a || !b) return a === b;
  return a.length === b.length && a.every((x, i) => x.kind === b[i]!.kind && sameStrings(x.globalIds, b[i]!.globalIds));
}

function sameClaim(a: ITaskStockClaim, b: ITaskStockClaim): boolean {
  return (
    a.id === b.id &&
    a.materialName === b.materialName &&
    a.fromCad === b.fromCad &&
    sameStrings(a.floorIds, b.floorIds) &&
    a.quantity === b.quantity &&
    a.unit === b.unit &&
    a.cadVersionId === b.cadVersionId &&
    a.keptOverCad === b.keptOverCad &&
    sameElements(a.elements, b.elements)
  );
}

/** Whether two claim lists are the same set, claim by claim, field by field. */
export function sameClaims(a: ITaskStockClaim[], b: ITaskStockClaim[]): boolean {
  return a.length === b.length && a.every((claim, i) => sameClaim(claim, b[i]!));
}
